import authReducers from "../../../web-sh/src/store/reducers/modules/auth"
import initial from "../../initial"

const userInfo = (state = initial.auth, action) => {
  switch (action.type) {
    default:
      return authReducers(state, action);
  }
};

export default userInfo;
